export const PLAYBACK_RATES = [0.8, 1, 1.2, 1.5, 2] as const;

export const ONE_MINUTE = 60;

export const VOD_FEATURE_FLAG = 'vodSpeedControls';

export const ADVERTISEMENT = 'advertisement';

export const CONTENT = 'content';

export const AD = 'ad';

export const AMPERWAVE_HLS_CONFIG = {
  maxBufferSize: 0,
  maxBufferLength: 60,
  backBufferLength: 0,
  // debug: true,
    playlistLoadPolicy: {
      default: {
        maxTimeToFirstByteMs: 10000,
        maxLoadTimeMs: 20000,
        timeoutRetry: {
          maxNumRetry: 5,
          retryDelayMs: 25000,
          maxRetryDelayMs: 5000,
        },
        errorRetry: {
          maxNumRetry: 5,
          retryDelayMs: 5000,
          maxRetryDelayMs: 8000,
        },
      },
    },
}